module.exports = __webpack_public_path__ + "static/media/1022744.0d4269fb.jpg";